import React from 'react';
import CardSyndic from './CardSyndic';
import CardAdresse from './CardAdresse';

const MonSyndic = () => (
    <div className="MonSyndic">
        <div className="row">
            <div className="col-lg-5">
                <CardSyndic full />
            </div>
            <div className="col-lg-7">
                <CardAdresse />
            </div>
        </div>
    </div>
);

export default MonSyndic;



// WEBPACK FOOTER //
// ./src/components/MonSyndic/index.js